import { useState, useEffect } from 'react';

import { useGetTransactonsQuery } from '@/modules/transactions';
import { showError } from '@/shared';

import type { TGetTransactions } from '@/modules/transactions/store/types';

const initialParams: TGetTransactions = {
  pageSize: 20,
  page: 1,
  ascending: false,
};

export const useGetTransactions = () => {
  const [params, setParams] = useState<TGetTransactions>(initialParams);
  const { data, isLoading, isError } = useGetTransactonsQuery(params);
  const itemsCount = data?.count;
  const items = data?.items ?? [];

  useEffect(() => {
    if (isError) {
      showError({ message: 'Произошла ошибка!' });
    }
  }, [isError]);

  const handleFilterChange = (data: TGetTransactions) => {
    setParams({ ...initialParams, ...data });
  };

  const handleFilterReset = () => {
    setParams({ ...initialParams });
  };

  const handlePaginationChange = (page: number) => {
    setParams((prev) => ({
      ...prev,
      page,
    }));
  };

  return {
    params,
    items,
    itemsCount,
    isLoading,
    handleFilterChange,
    handleFilterReset,
    handlePaginationChange,
  };
};
